import { createContext } from "react";

import { CommsScheduleHelper } from "./CommsScheduleHelper.ts";

export const CommsScheduleContext = createContext<CommsScheduleHelper>(
  {} as CommsScheduleHelper
);
